import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = [
    "box",
    "icon",
    "image",
    "input",
    "slider"
  ]

  initialize() {
    this.isDragging = false
    this.startX = 0
    this.startY = 0
    this.translateX = 0
    this.translateY = 0
  }

  select(event) {
    if (this.imageTarget.src && !this.imageTarget.classList.contains("d-none") && event.target !== this.inputTarget) {
      return
    }
    this.inputTarget.click()
  }

  // Bound to the explicit "Select File" button -- unlike select() (bound to the box itself),
  // this always opens the file picker even when an image is already loaded. select()'s guard
  // exists so clicking an already-loaded box pans/zooms instead of re-opening the file picker;
  // that guard should never apply to a dedicated "pick a new file" button.
  chooseFile() {
    this.inputTarget.click()
  }

  preview(event) {
    const file = event.target.files[0]

    if (!file) return

    const reader = new FileReader()

    reader.onload = ({ target }) => {
      this.boxTarget.classList.add("box--bg")

      this.iconTarget.classList.add("d-none")

      this.lastDataUrl = target.result
      this.imageTarget.src = target.result
      this.imageTarget.classList.remove("d-none")

      this.translateX = 0
      this.translateY = 0
      this.zoom()

      const selectedEvent = new CustomEvent("photo-upload:selected", {
        bubbles: true,
        cancelable: true,
        detail: { file }
      })
      this.element.dispatchEvent(selectedEvent)
    }

    reader.readAsDataURL(file)
  }

  zoom() {
    if (!this.imageTarget.src) return

    this.imageTarget.style.transform = `translate(${this.translateX}px, ${this.translateY}px) scale(${this.sliderTarget.value})`
  }

  startDrag(event) {
    if (!this.imageTarget.src || this.imageTarget.classList.contains("d-none")) return
    
    if (event.type === "mousedown") {
      event.preventDefault()
    }
    
    this.isDragging = true
    const clientX = event.touches ? event.touches[0].clientX : event.clientX
    const clientY = event.touches ? event.touches[0].clientY : event.clientY
    
    this.startX = clientX - this.translateX
    this.startY = clientY - this.translateY
  }

  drag(event) {
    if (!this.isDragging) return
    
    const clientX = event.touches ? event.touches[0].clientX : event.clientX
    const clientY = event.touches ? event.touches[0].clientY : event.clientY
    
    this.translateX = clientX - this.startX
    this.translateY = clientY - this.startY
    
    this.imageTarget.style.transition = "none"
    this.zoom()
  }

  stopDrag() {
    if (!this.isDragging) return
    this.isDragging = false
    this.imageTarget.style.transition = "transform 0.2s ease"
  }

  remove() {
    this.inputTarget.value = ""
    this.lastDataUrl = null

    this.sliderTarget.value = 1

    this.boxTarget.classList.remove("box--bg")

    this.translateX = 0
    this.translateY = 0

    this.imageTarget.src = ""
    this.imageTarget.classList.add("d-none")
    this.imageTarget.style.transform = "scale(1)"

    this.iconTarget.classList.remove("d-none")

    const removedEvent = new CustomEvent("photo-upload:removed", {
      bubbles: true,
      cancelable: true
    })
    this.element.dispatchEvent(removedEvent)
  }

  upload() {
    const file = this.inputTarget.files[0]

    if (!file || !this.lastDataUrl) return window.Gv3Toast.warning("Please select a photo first.") // nothing picked yet -- was a silent no-op

    const uploadEvent = new CustomEvent("photo-upload:upload", {
      bubbles: true,
      cancelable: true,
      detail: { file, dataUrl: this.lastDataUrl }
    })
    this.element.dispatchEvent(uploadEvent)
  }
}